'helper'.trashAll('POReceipt')
'helper'.trashAll('PO')
'helper'.trashAll('Supplier')
'helper'.trashAll('Avenue')
'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('Castaways')
    'OK'.click()
  'Back'.click()
'Inventory'.click()
  'mainTable./Cap (C01)/.Include'.shouldntExist()
  'Labels'.click()
    'mainTable./Cap (C01)/.Include'.shouldBeUnticked()
    'Select None'.shouldntExist()
    'Select All'.click()
    'Select All'.shouldntExist()
    'mainTable./Cap (C01)/.Include'.shouldBeTicked()
    'mainTable./Hoodie (H01)/.Include'.shouldBeTicked()
    'Select None'.click()
    'Select None'.shouldntExist()
    'Select All'.shouldExist()
    'mainTable./Cap (C01)/.Include'.shouldBeUnticked()
    'mainTable./Hoodie (H01)/.Include'.shouldBeUnticked()
    'mainTable./Cap (C01)/.Include'.toggleTick()
    'mainTable./Hoodie (H01)/.Include'.toggleTick()
    'mainTable./Cap (C01)/.Include'.shouldBeTicked()
    'mainTable./Hoodie (H01)/.Include'.shouldBeTicked()
    'Produce Labels'.click()
      'Download Labels PDF'.click()
      'Back'.click()
    'Back'.click()
  'Produce Labels'.shouldntExist()
  'mainTable./Cap (C01)/.Include'.shouldntExist()
  'Labels'.click()
    'mainTable./Cap (C01)/.Include'.shouldBeTicked()
    'mainTable./Hoodie (H01)/.Include'.shouldBeTicked()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'Adjust Quantity On Hand'.click()
      'Quantity'.enter('20')
      'OK'.click()
    'Add Supplier'.click()
      'Supplier'.enter('Castaways')
      'Recommended Retail Price (inc Tax)'.enter('25.50')
      'Barcode'.enter('1726928618088791')
      'OK'.click()
    'OK'.click()
  'mainTable./Cap (C01)/.Labels'.click()
    'Labels'.shouldBeCurrentPage()
    'Label Type'.shouldEqual('Inventory')
    'Source Type'.shouldEqual('Product')
    'Source Reference'.shouldEqual('Cap (C01)')
    'Download Labels PDF'.click()
    'Layout'.click()
      'Add Field'.click()
        'Add Label Field'.shouldBeCurrentPage()
        'Get Value From'.enter('Caption Only')
        'Caption'.enter('Test Big Bold Caption')
        'Distance from Left of Label (mm)'.shouldEqual('0')
        'Distance from Left of Label (mm)'.enter('20')
        'Distance from Top of Label (mm)'.shouldEqual('0')
        'Distance from Top of Label (mm)'.enter('1')
        'Maximum Width (mm)'.shouldEqual('50')
        'Maximum Width (mm)'.enter('30')
        'Height (mm)'.shouldntExist()
        'Font Size'.shouldEqual('10')
        'Font Size'.enter('14')
        'Bold'.shouldEqual('No')
        'Bold'.enter('Yes')
        'OK'.click()
      'Add Field'.click()
        'Get Value From'.clickDropdown()
        'Get Value From'.shouldHaveOption('Inventory.barcode')
        'Get Value From'.enter('Inventory.barcode')
        'Caption'.enter('Barcode')
        'Distance from Top of Label (mm)'.enter('1')
        'Distance from Left of Label (mm)'.enter('20')
        'Display As'.clickDropdown()
        'Display As'.shouldHaveOption('Barcode')
        'Display As'.enter('Barcode')
        'Font Size'.shouldntExist()
        'Bold'.shouldntExist()
        'Height (mm)'.shouldEqual('10')
        'Height (mm)'.enter('5')
        'OK'.click()
      'OK'.click()
    'Download Labels PDF'.click()
    'Back'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'Labels'.click()
      'Labels'.shouldBeCurrentPage()
      'Label Type'.shouldEqual('Inventory')
      'Source Type'.shouldEqual('Product')
      'Source Reference'.shouldEqual('Cap')
      'Download Labels PDF'.click()
      'Back'.click()
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Supplier'.enter('Castaways')
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Quantity'.enter('10')
      'Unit Price (Inc Tax)'.enter('987.65')
      'OK'.click()
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Quantity'.enter('100')
      'Unit Price (Inc Tax)'.enter('0.95')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'Receive Purchases'.click()
  'mainTable.1.Enter Receipt'.click()
    'Labels'.click()
      'Labels'.shouldBeCurrentPage()
      'Label Type'.shouldEqual('Inventory')
      'Label Type'.shouldBeReadOnly()
      'Source Type'.shouldEqual('Purchase Order Receipt')
      'Source Type'.shouldBeReadOnly()
      'Source Reference'.shouldEqual('PO00001-01')
      'Source Reference'.shouldBeReadOnly()
      'Download Labels PDF'.click()
      'Layout'.click()
        'Labels Layout'.shouldBeCurrentPage()
        'Page Width (mm)'.shouldEqual('210')
        'Page Height (mm)'.shouldEqual('270')
        'Number of Labels Across Page'.shouldEqual('2')
        'Number of Labels Down Page'.shouldEqual('7')
        'Page Left Margin (mm)'.shouldEqual('0')
        'Page Top Margin (mm)'.shouldEqual('0')
        'Label Width (mm)'.shouldEqual('105')
        'Label Height (mm)'.shouldEqual('38.57')
        'Horizontal Gap Between Labels (mm)'.shouldEqual('0')
        'Vertical Gap Between Labels (mm)'.shouldEqual('0')
        'Number of Labels Across Page'.enter('3')
        'Number of Labels Down Page'.enter('10')
        'Page Left Margin (mm)'.enter('20')
        'Page Top Margin (mm)'.enter('12.5')
        'Label Width (mm)'.enter('50')
        'Label Height (mm)'.enter('20')
        'Horizontal Gap Between Labels (mm)'.enter('10')
        'Vertical Gap Between Labels (mm)'.enter('5')
        'Fields.0.Get Value From'.shouldEqual('Inventory.sku')
        'Fields.0.Left'.shouldEqual('5')
        'Fields.0.Top'.shouldEqual('3')
        'Fields.1.Get Value From'.shouldEqual('Inventory.productName')
        'Fields.1.Left'.shouldEqual('5')
        'Fields.1.Top'.shouldEqual('12')
        'Fields.0.Edit'.click()
          'Distance from Top of Label (mm)'.enter(1)
          'OK'.click()
        'Fields.1.Edit'.click()
          'Distance from Top of Label (mm)'.enter(6)
          'OK'.click()
        'Add Field'.click()
          'Get Value From'.clickDropdown()
          'Get Value From'.shouldHaveOption('Inventory.lastPurchaseUnitCostIncTax')
          'Get Value From'.chooseOption('Inventory.lastPurchaseUnitCostIncTax')
          'Caption'.enter('Price')
          'Display As'.enter('Number')
          'Minimum Decimals'.enter('2')
          'Maximum Decimals'.enter('2')
          'Distance from Left of Label (mm)'.enter('20')
          'Distance from Top of Label (mm)'.enter('12')
          'Maximum Width (mm)'.enter('20')
          'Font Size'.enter('8')
          'OK'.click()
        'Add Field'.click()
          'Get Value From'.chooseOption('POReceiptLine.recommendedRetailPriceIncTax')
          'Caption'.enter('RRP')
          'Display As'.enter('Number')
          'Minimum Decimals'.enter('2')
          'Maximum Decimals'.enter('2')
          'Distance from Left of Label (mm)'.enter('20')
          'Distance from Top of Label (mm)'.enter('17')
          'Maximum Width (mm)'.enter('20')
          'Font Size'.enter('8')
          'OK'.click()
        'Add Field'.click()
          'Get Value From'.clickDropdown()
          'Get Value From'.shouldHaveOption('POReceiptLine.barcode')
          'Get Value From'.enter('POReceiptLine.barcode')
          'Caption'.enter('Barcode 2')
          'Distance from Top of Label (mm)'.enter('1')
          'Distance from Left of Label (mm)'.enter('20')
          'Display As'.enter('Barcode')
          'OK'.click()
        'OK'.click()
      'Download Labels PDF'.click()
      'Back'.click()
    'Back'.click()
  'mainTable'.shouldBeEmpty()
  'Back'.click()
'helper'.simulateBrowserRefresh()
'Receive Purchases'.click()
  'View All Receipts'.click()
    'mainTable.0.Edit'.click()
      'Labels'.click()
        'Layout'.click()
          'Fields'.shouldHaveCount(7)
          'Back'.click()
        'Back'.click()
      'Back'.click()
    'Back'.click()
  'Back'.click()
